/** Remove the static HTML boot splash once React renders a loading shell. */
export function dismissHtmlBootSplash(): void {
  document.getElementById('boot-splash')?.remove()
}
